import { proxy } from 'valtio';

export const labelState = proxy({
    imageURL: './images/0121_NFT_Label.png',
    imageCropped: null,
    showUI: true
});
